import GymCoachComponent from "pages/Components/GymCoachComponent/GymCoachComponent";
import "./GymCoaches.scss";
import VectorUnderline from "pages/Components/VectorUnderline/VectorUnderline";
import { useNavigate } from "react-router-dom";
import CommonButton from "pages/Components/CommonButton/CommonButton";
import FirstCoach from "images/Coach1Img.webp";
import SecondCoach from "images/Coach2Img.webp";
import ThirdCoach from "images/Coach3Img.webp";
import FourthCoach from "images/Coach4Img.webp";
import FifthCoach from "images/Coach5Img.webp";
import { useState } from "react";

type CoachModalData = {
  name: string;
  fullName: string;
  image: string;
  specialty: string;
  description: string;
  bullets?: string[];
  trainees?: { name: string; achievement: string }[];
  services?: string[];
  links?: { label: string; url: string }[];
  phone: string;
};

const coachModals: Record<string, CoachModalData> = {
  andrzej: {
    name: "Trener Andrzej",
    fullName: "Andrzej Dziedzic",
    image: ThirdCoach,
    specialty: "Trener · Trójbój siłowy",
    description:
      "Trenuję już od 11 lat — z początku jako zawodnik, teraz jako trener. Jestem dla ludzi z każdym poziomem: pomogę Ci stawiać pierwsze kroki, ale też zdobywać pierwsze zwycięstwa. Chcesz postawić na profesjonalizm i wieloletnie doświadczenie poparte wynikami podopiecznych? Napisz do mnie lub po prostu zagadaj!",
    services: [
      "Trening siłowy, motoryczny i rehabilitacyjny",
      "Przygotowanie do zawodów trójboju siłowego",
      "Rehabilitacja i poprawa kondycji ciała",
      "Przygotowanie do walk w ringu",
      "Możliwość treningów online",
    ],
    links: [
      {
        label: "Instagram",
        url: "https://www.instagram.com/andrzej_dziedzic_/",
      },
    ],
    phone: "537 240 394",
  },
  piotr: {
    name: "Piotr Jakubiec",
    fullName: "Piotr Jakubiec",
    image: FourthCoach,
    specialty: "Trener personalny",
    description:
      "Trener personalny i instruktor siłowni. Sam przeszedłem dużą przemianę, redukując około 40 kg, dlatego wiem, z czym wiąże się cały proces zmiany sylwetki. Stawiam na prawidłową technikę, bezpieczeństwo oraz trening dopasowany do możliwości i celu konkretnej osoby. Specjalizuję się przede wszystkim w treningu kobiet, redukcji tkanki tłuszczowej i poprawie sprawności.",
    services: [
      "Trening Personalny 1 na 1 - indywidualne podejście i nauka techniki",
      "Trening kobiet - sylwetka, sprawność i pewność na siłowni",
      "Redukcja tkanki tłuszczowej - trening i wsparcie w zmianie nawyków",
      "Trening sylwetkowy - poprawa wyglądu i proporcji sylwetki",
      "Poprawa sprawności i wzorców ruchowych",
      "Medyczny trening personalny — trening z uwzględnieniem ograniczeń",
      "Stretching i ćwiczenia korekcyjne",
      "Wsparcie żywieniowe - praktyczne wskazówki dotyczące diety",
    ],
    links: [
      { label: "Strona www", url: "https://ogrodniknaredukcji.pl" },
      {
        label: "Instagram",
        url: "https://www.instagram.com/ogrodnik_na_redukcji/",
      },
    ],
    phone: "535 991 986",
  },
  leszek: {
    name: "Trener Leszek",
    fullName: "Leszek Sznajdrowicz",
    image: FifthCoach,
    specialty: "Trening personalny",
    description:
      "Oferuję kompleksową opiekę trenerską — niezależnie od tego, czy stawiasz pierwsze kroki na siłowni, czy dążysz do konkretnego celu sylwetkowego lub siłowego. Każdy podopieczny otrzymuje indywidualnie dopasowany plan i stałe wsparcie.",
    services: [
      "Trening personalny 1:1 — pełne skupienie na efekcie",
      "Trening we dwoje — motywacja i lepsze wyniki",
      "Prowadzenie online — plan i stałe wsparcie",
      "Budowa sylwetki — masa i estetyczna forma",
      "Redukcja tkanki tłuszczowej — szybciej i trwale",
      "Siła i sprawność — forma na co dzień",
      "Nauka techniki — bezpiecznie i efektywnie",
      "Plan żywieniowy — prosty, dopasowany, działający",
    ],
    links: [
      {
        label: "Instagram",
        url: "https://www.instagram.com/leszeksznajdrowicz/",
      },
    ],
    phone: "601 963 996",
  },
};

const GymCoaches = () => {
  const navigate = useNavigate();
  const [activeModal, setActiveModal] = useState<string | null>(null);
  const modal = activeModal ? coachModals[activeModal] : null;

  const openModal = (key: string) => {
    setActiveModal(key);
    document.body.style.overflow = "hidden";
    document.body.classList.add("modal-open");
  };

  const closeModal = () => {
    setActiveModal(null);
    document.body.style.overflow = "";
    document.body.classList.remove("modal-open");
  };

  return (
    <section>
      <div className="gymCoachesComponent">
        <div className="gymCoachesTitle">Dostępni trenerzy</div>
        <VectorUnderline noLeft />
        <p className="gymCoachesSubtitle">
          Centrum Siły wspiera swoich trenerów w ciągłym rozwoju — zarówno
          zawodniczym, jak i dydaktycznym. Każdy z nich podchodzi do pracy z
          podopiecznymi indywidualnie, a ich sukcesy mówią same za siebie.
          Kliknij <div className="gymCoachesSubtitleHighlight">ℹ</div> na
          wybranych trenerach, aby poznać ich ofertę.
        </p>
      </div>
      <div className="gymCoachesWrapper">
        <GymCoachComponent
          image={ThirdCoach}
          alt="Andrzej Coach"
          description="Andrzej Dziedzic"
          phoneNumber="537 240 394"
          hasInfo
          onInfoClick={() => openModal("andrzej")}
        />
        <GymCoachComponent
          image={FifthCoach}
          alt="Leszek Sznajdrowicz"
          description="Leszek Sznajdrowicz"
          phoneNumber="601 963 996"
          hasInfo
          onInfoClick={() => openModal("leszek")}
        />
        <GymCoachComponent
          image={FourthCoach}
          alt="Piotr Jakubiec"
          description="Piotr Jakubiec"
          phoneNumber="535 991 986"
          hasInfo
          onInfoClick={() => openModal("piotr")}
        />
        <GymCoachComponent
          image={SecondCoach}
          alt="Bartek Coach"
          description="Bartek Gruszecki"
          phoneNumber="730 273 580"
        />
        <GymCoachComponent
          image={FirstCoach}
          alt="Karolina Coach"
          description="Karolina Jasek"
          phoneNumber="789 246 311"
        />
      </div>
      <div className="gymCoachesButtonWrapper">
        <CommonButton
          text="Sukcesy trenerów"
          onClick={() => navigate("/coaches-achievements")}
        />
      </div>

      {/* ── Coach Modal ─────────────────────────────── */}
      {modal && (
        <div
          className="coachModalOverlay"
          onClick={closeModal}
          role="dialog"
          aria-modal="true">
          <div className="coachModalBox" onClick={(e) => e.stopPropagation()}>
            <button
              className="coachModalClose"
              onClick={closeModal}
              aria-label="Zamknij">
              ✕
            </button>
            <div className="coachModalHeader">
              <div className="coachModalImgWrapper">
                <img
                  src={modal.image}
                  alt={modal.fullName}
                  className="coachModalImg"
                />
              </div>
              <div className="coachModalHeaderContent">
                <div className="coachModalSpecialty">{modal.specialty}</div>
                <div className="coachModalName">{modal.fullName}</div>
                <p className="coachModalDesc">{modal.description}</p>
              </div>
            </div>
            {modal.bullets && (
              <div className="coachModalSection">
                <div className="coachModalSectionTitle">Szczegóły</div>
                <ul className="coachModalServices">
                  {modal.bullets.map((b, i) => (
                    <li
                      key={i}
                      className="coachModalServiceItem coachModalServiceItemEmoji">
                      {b}
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {modal.services && (
              <div className="coachModalSection">
                <div className="coachModalSectionTitle">Co oferuje</div>
                <ul className="coachModalServices">
                  {modal.services.map((s, i) => (
                    <li key={i} className="coachModalServiceItem">
                      {s}
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {modal.links && (
              <div className="coachModalSection coachModalLinksSection">
                {modal.links.map((l, i) => (
                  <a
                    key={i}
                    href={l.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="coachModalLink">
                    {l.label} ↗
                  </a>
                ))}
              </div>
            )}
            {modal.phone && modal.phone !== "-" && (
              <a
                href={`tel:${modal.phone.replace(/\s/g, "")}`}
                className="coachModalCta">
                <span className="coachModalCtaLabel">Telefon</span>
                <span className="coachModalCtaPhone">{modal.phone}</span>
              </a>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default GymCoaches;
